// TODO replace this with profile.formatJobInfo

const formatJobInfo = (jobtitle: string, company:string): string => {
    const optionalAt = jobtitle && company ? '@' : ''
    return (`${jobtitle} ${optionalAt} ${company}`)
}

export default formatJobInfo
